import React from 'react';

export const Review = ({ width = 16, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 14C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H1C0.447715 16 0 15.5523 0 15C0 14.4477 0.447715 14 1 14H15ZM4.29289 7.29289L11.2929 0.292893C11.6534 -0.0675907 12.2206 -0.0953203 12.6129 0.209705L12.7071 0.292893L15.7071 3.29289C16.0676 3.65338 16.0953 4.22061 15.7903 4.6129L15.7071 4.70711L8.70711 11.7071C8.55083 11.8634 8.34815 11.9626 8.13144 11.9913L8 12H5C4.48716 12 4.06449 11.614 4.00673 11.1166L4 11V8C4 7.77899 4.07316 7.56552 4.20608 7.39197L4.29289 7.29289L11.2929 0.292893L4.29289 7.29289ZM12 2.41421L6 8.41421V10H7.58579L13.5858 4L12 2.41421Z"
      fill="white"
    />
  </svg>
);
